import { useTranslation } from 'react-i18next';
import * as DOMPurify from 'dompurify';
import { useMemo } from 'react';
import BaseWidget from '../base-widget/base-widget.component';
import { THEME } from '../../../../../../themes';
import STRING_KEYS from '../../../../../../language/keys';
import { Content, Icon, TooltipBubble } from './evidence-widget.styled';
import { EvidenceWidgetProps } from './evidence-widget';

const EvidenceWidget = ({ evidence }: EvidenceWidgetProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const toolTipTitle = useMemo((): string => {
    if (!evidence.paragraph || !evidence.quote) {
      return '';
    }

    return evidence.paragraph.replace(evidence.quote, `<b><i>${evidence.quote}</i></b>`);
  }, [evidence.paragraph, evidence.quote]);

  return (
    <BaseWidget
      title={ translate(STRING_KEYS.MATCH_WIDGETS.EVIDENCE.TITLE) }
      Icon={ Icon }
      titleColor={ THEME.COLORS.DECOR }
    >
      <TooltipBubble
        title={ <div dangerouslySetInnerHTML={ { __html: DOMPurify.sanitize(toolTipTitle) } } /> }
        placement="bottom"
        arrow={ false }
        enterNextDelay={ 500 }
        enterDelay={ 500 }
      >
        <Content>
          “...{ evidence.quote }...“
        </Content>
      </TooltipBubble>
    </BaseWidget>
  );
};

export default EvidenceWidget;
